export default "__VITE_ASSET__DDl3H0Fs__"